<div *ngIf="ViewReady">
    <h2 class="mat-title">
        DELTA Issue Alerts
    </h2>
    <div>
        <div>There are currently {{AlertsList?.length || 0}} Issue Alerts in the DELTA System. Of these, {{InEffectCount || 0}} are in effect.</div>
        <div>You may view all Issue Alerts below. Use the filters provided to analyze, sort, or otherwise manage the display of the Issue Alerts on file.</div>
    </div>

    <!-- New Alert Form -->
    <div class="mat-elevation-z12 padding">
        <form [formGroup]="NewAlertForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxFlex.gt-sm="65" fxFlex.lt-md="auto" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <form-label>Alert Message: </form-label>
                    <mat-form-field fxFlex>
                        <textarea matInput formControlName="AlertMessage" placeholder="Enter alert message here..." matTextareaAutosize matAutosizeMinRows="3"></textarea>
                        <mat-error *ngIf="NewAlertForm.get('AlertMessage').hasError('required')">Alert message required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <mat-form-field>
                        <input type="text" matInput formControlName="DateBegin" placeholder="Begin date..." />
                        <mat-hint align="start">M/D/YYYY H:MM AM/PM Format</mat-hint>
                    </mat-form-field>
                    <mat-form-field>
                        <input type="text" matInput formControlName="DateEnd" placeholder="End date..." />
                        <mat-hint align="start">M/D/YYYY H:MM AM/PM Format</mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <button type="text" *ngIf="NewAlertForm.get('IsUpdate').value != true" mat-raised-button color="primary" (click)="AddNewAlert()" [disabled]="NewAlertForm.invalid">
                <span>Add Alert</span>
            </button>
            <button type="text" *ngIf="NewAlertForm.get('IsUpdate').value == true" mat-raised-button color="primary" (click)="UpdateExistingAlert()" [disabled]="NewAlertForm.invalid">
                <span>Update Alert</span>
            </button>
            <button type="text" mat-raised-button color="warn" (click)="NewAlertForm.reset()">
                <span>{{NewAlertForm.get('IsUpdate').value ? 'Cancel' : 'Reset'}}</span>
            </button>
        </div>
    </div>

    <form>
        <form-label>Display Filter: </form-label>
        <mat-form-field class="displaylist">
            <mat-select [(ngModel)]="AlertsDisplayMode" [ngModelOptions]="{standalone: true}" (change)="UpdateAlertDisplayMode($event)">
                <mat-option value="A">All Alerts</mat-option>
                <mat-option value="I">In-Effect Alerts</mat-option>
                <mat-option value="X">Expired Alerts</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
    <!-- Alerts Table -->
    <mat-table class="bordered" #table [dataSource]="AlertsData" matSort matSortActive="DateBegin" matSortDirection="desc">
        <ng-container matColumnDef="IssueAlertNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered"><span>Alert #</span></mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered"><span>{{alert.WebAppIssueAlertID}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="AlertMessage">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Message</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered">
                <span [innerHTML]="alert.AlertMessage | safeHTML"></span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateBegin">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Begin Date</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered"><span *ngIf="alert.DateBegin">{{alert.DateBegin | datefns:'M/D/YYYY h:mm A'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateEnd">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">End Date</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered"><span *ngIf="alert.DateEnd">{{alert.DateEnd | datefns:'M/D/YYYY h:mm A'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="InEffect">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">In Effect?</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered"><span>{{alert.InEffect | yesNo}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="AddedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Added By</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered">
                <span *ngIf="alert.AddedByLastName">{{alert.AddedByLastName | titleCase}}, {{alert.AddedByFirstName | titleCase}}</span>
                <span *ngIf="alert.AddedByEmail">{{alert.AddedByEmail}}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="LastUpdated">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Last Updated</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered"><span *ngIf="alert.LastUpdated">{{alert.LastUpdated | datefns:'M/D/YYYY h:mm A'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let alert" class="centered">
                <div class="padding-top padding-bottom" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <button mat-raised-button color="primary" (click)="LoadUpdateForm(alert)">
                        <span>Update</span>
                    </button>
                    <button mat-raised-button color="accent" (click)="DisableAlert(alert)">
                        <span>Disable</span>
                    </button>
                    <button *ngIf="User.IsDeveloper" mat-raised-button color="warn" (click)="RemoveAlert(alert)">
                        <span>Remove</span>
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Alert(s)</mat-header-cell>
            <mat-cell *matCellDef="let alert">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Alert #</form-label>
                        <span>{{alert.WebAppIssueAlertID}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Message</form-label>
                        <span [innerHTML]="alert.AlertMessage | safeHTML"></span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Begin</form-label>
                        <span *ngIf="alert.DateBegin">{{alert.DateBegin | datefns:'M/D/YYYY h:mm A'}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>End</form-label>
                        <span *ngIf="alert.DateEnd">{{alert.DateEnd | datefns:'M/D/YYYY h:mm A'}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>In-Effect</form-label>
                        <span>{{alert.InEffect | yesNo}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Added By</form-label>
                        <span>{{alert.AddedByLastName | titleCase}}, {{alert.AddedByFirstName | titleCase}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Last Updated</form-label>
                        <span *ngIf="alert.LastUpdated">{{alert.LastUpdated | datefns:'M/D/YYYY h:mm A'}}</span>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="LoadUpdateForm(alert)">
                            <span>Update</span>
                        </button>
                        <button mat-raised-button color="accent" (click)="DisableAlert(alert)">
                            <span>Disable</span>
                        </button>
                        <button *ngIf="User.IsDeveloper" mat-raised-button color="warn" (click)="RemoveAlert(alert)">
                            <span>Remove</span>
                        </button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let alert"><em>
                <span *ngIf="AlertsDisplayMode == 'A'">No Alerts have been filed for the DELTA System.</span>
                <span *ngIf="AlertsDisplayMode != 'A' && !!AlertsList.length">No Alerts matching the specified filter have been filed for the DELTA System.</span>
            </em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns;let $even = even" [class.primarybackground50]="$even && !row.InEffect" [class.red500-02]="row.InEffect"></mat-row>
    </mat-table>
    <mat-paginator #paginator [length]="FilteredAlertsList?.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/issuealert/issuealert.component.html